import ApiService from 'app/api/api-service';

export const fetchCategory = async () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const url = `${BASE_URL}/api/category`;
  const response = await ApiService.get(url);
  return response.data;
};
